var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBessGridCharged(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0208 8.83333V7.8125C18.0208 7.27102 17.8057 6.75171 17.4228 6.36882C17.04 5.98594 16.5207 5.77083 15.9792 5.77083H15.4688C15.187 5.77083 14.9583 5.54217 14.9583 5.26042C14.9583 4.97867 14.7297 4.75 14.4479 4.75H11.3854C11.1037 4.75 10.875 4.97867 10.875 5.26042C10.875 5.54217 10.6463 5.77083 10.3646 5.77083H9.85417C9.31268 5.77083 8.79338 5.98594 8.41049 6.36882C8.0276 6.75171 7.8125 7.27102 7.8125 7.8125V19.0417C7.8125 19.5832 8.0276 20.1025 8.41049 20.4853C8.79338 20.8682 9.31268 21.0833 9.85417 21.0833H10.875M15.9792 22.1042V19.0417M13.9375 14.9583V12.4063M18.0208 14.9583V12.4063M12.9167 14.9583H19.0417V17C19.0417 17.5415 18.8266 18.0608 18.4437 18.4437C18.0608 18.8266 17.5415 19.0417 17 19.0417H14.9583C14.4168 19.0417 13.8975 18.8266 13.5147 18.4437C13.1318 18.0608 12.9167 17.5415 12.9167 17V14.9583Z",
    stroke: "#2B8D3F",
    strokeWidth: 2.04167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBessGridCharged);
export default __webpack_public_path__ + "static/media/bess_grid_charged.1cdd4fd37ca871ee8e1b5cb8883c9b24.svg";
export { ForwardRef as ReactComponent };